import './Footer.css'



export default function Footer() {
    return (
        <>
            <section>
                <footer class="footer">
                    <div class="container">
                        <div class='content'>
                            <p>© 2024 sainuk, desgined by  <a href='https://jamshidct.me/' class="link">jamshid ct</a> </p>
                            <ul class="social-links">
                                <li><a href="https://www.linkedin.com/in/sainu123" class="link"><i
                                    class="fab fa-brands fa-linkedin-in"></i></a></li>
                                <li><a href="https://dribbble.com/sainumechpd" class="link"><i class="fab fa-brands fa-dribbble"></i></a></li>
                                <li><a href="https://www.behance.net/sainumechpd" class="link"><i class="fab fa-behance"></i></a></li>
                                <li><a href="https://www.instagram.com/sainu_uxdesign/" class="link"><i class="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>

                    </div>
                </footer>
            </section>
        </>
    )
}